import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import Document from "./Document";
import { NavLink } from 'react-router-dom';

export default class TransctionsReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true,
            fromDate: null,
            toDate: null,
            configName: 'transactions_report',
        }
    }
    componentDidMount() {
        this.getData();
    }
    componentWillReceiveProps(props) {
        this.state.id = props.Id;
        this.getData();
    }
    getData() {
        this.httpPost("api/v1/report/transactions", {
            id: this.getCurrentFormId(),
            mcode: parseInt(this.getQueryString("mcode", 0)),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    showDocument(id) {
        this.showComponents({ component: <Document Caller={this} Id={id} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "fullCode", caption: "کدحساب", show: true },
                { field: "title", caption: "نام حساب", show: true },
                { field: "bed", caption: "گردش بدهکار", show: true },
                { field: "bes", caption: "گردش بستانکار", show: true },
                { field: "remainBed", caption: "مانده بدهکار", show: true },
                { field: "remainBes", caption: "مانده بستانکار", show: true },
            ]
        }
    }
    getColumns() {
        var t = [];
        t.push({ field: "date", headerName: "تاریخ" });
        t.push({ field: "description", headerName: "شرح سند" });
        t.push({ field: "number2", headerName: "شماره عطف" });
        t.push({ field: "number", headerName: "شماره سند" });
        t.push({ field: "bed", headerName: "بدهکار", cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bed) } });
        t.push({ field: "bes", headerName: "بستانکار", cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bes) } });
        return t;
    }
    renderForm() {
        return <div className="container">
            <div className="row">
                <div className="col-sm-12">
                    <div className="panel panel-info">
                        <div className="panel-body">
                            <div className="col-sm-10">
                                <NavLink className="text-primary txt-bold hand" to={"/report/explore3u/" + this.state.data.account.id + "/"}>نمایش گردش معین های مرتبط با {this.state.data.account.title}</NavLink>
                            </div>
                            <div className="col-sm-2 text-left">
                                <button className="btn btn-no-frame btn-smoke hand" onClick={e => this.onPrint('گردش حساب')} title="چاپ">
                                    <span className="fa fa-print"></span>
                                </button>
                                <button className="btn btn-no-frame btn-smoke hand" onClick={e => this.onPdf('گردش حساب')} title="PDF">
                                    <span className="fa fa-file-pdf-o"></span>
                                </button>
                                <button className="btn btn-no-frame btn-smoke hand" onClick={e => this.onExcel('گردش حساب')} title="اکسل">
                                    <span className="fa fa-file-excel-o"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {this.renderAgGrid({
                columnDefs: this.getColumns(),
            })}
        </div>
    }
    setAgGridSelectedRow(e) {
        var t = [];
        e.forEach(ee => t.push(ee.id));
        this.state.selectedIds = t;
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent(),
                <Footer />
            ];

        return contents;
    }
}